<ng-container *ngIf="currentPage$ | async as currentPage">
  <app-matching *ngIf="currentPage === MATCHING" [@slideInOut]></app-matching>
  <app-sms-verification *ngIf="currentPage === SMS_VERIFICATION" [@slideInOut]></app-sms-verification>
  <app-email-verification *ngIf="currentPage=== EMAIL_VERIFICATION" [@slideInOut]></app-email-verification>
  <app-cognito-verification *ngIf="currentPage=== COGNITO_VERIFICATION" [@slideInOut]></app-cognito-verification>
  <app-additional-match *ngIf="currentPage=== ADDITIONAL_MATCH" [@slideInOut]></app-additional-match>
</ng-container>
